import {getDefaultGridOptions} from "./grid/defaultGridOptions";
import {clientSide} from "./grid/clientSide";
import {currencyFormatter, floatFormatter, intFormatter, percentFormatter} from "./grid/helpers/formatters";
import {avgAggFunction} from "./grid/helpers/avgAggFunction";
import {czechLocaleText} from "./grid/helpers/localization";
import {gridToolbarItems} from "./grid/toolbar/items";
import {saveGridFilter} from "./grid/states/filter";
import {saveGridLayout} from "./grid/states/layout";
import {serverSide, serverSideTree} from "./grid/serverSide";
import {getSelectedRowIds} from "./grid/helpers/getSelectedRowIds";
import {getEshopSwitcher} from "./grid/components/eshopSwitcher";

agGrid.LicenseManager.setLicenseKey("CompanyName=BRASTY GROUP s.r.o.,LicensedApplication=K1,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-027730,ExpiryDate=19_June_2023_[v2]_MTY4NzEyOTIwMDAwMA==f83571df126afca475ea713ae89e3774");

var gridSettings = {};
var detailLink = '';

window.gridSettings = gridSettings;
window.detailLink = detailLink;
window.actualGridFilterSettingsId = null;
window.actualGridLayoutSettingsId = null;

window.defaultGridOptions = getDefaultGridOptions()
window.initializeClientSideGrid = clientSide;
window.initializeServerSideTree = serverSideTree;
window.initializeServerSideGrid = serverSide;

window.percentFormatter = percentFormatter
window.floatFormatter = floatFormatter
window.intFormatter = intFormatter
window.currencyFormatter = currencyFormatter
window.avgAggFunction = avgAggFunction
window.czechLocaleText = czechLocaleText
window.gridToolbarItems = gridToolbarItems
window.saveGridFilter = saveGridFilter;
window.saveGridLayout = saveGridLayout;
window.getSelectedRowIds = getSelectedRowIds;
window.getEshopSwitcher = getEshopSwitcher;
